export const ParkingPage = () => {
  return <div>ParkingPage</div>;
};
